import React from 'react'
import Filtro from '../comum/Filtro'
import FiltrosAdicionadosItinerarios from './FiltrosAdicionadosItinerarios'
import FiltroItinerarios from './FiltroItinerarios'
import PainelFiltragem from '../comum/PainelFiltragem'

export const PainelFiltroItinerarios = () => (
  <Filtro PainelFiltro={FiltroItinerarios}/>
);

const PainelFiltrosItinerarios = () => (
  <PainelFiltragem
    Filtro={PainelFiltroItinerarios}
    FiltrosAdicionados={FiltrosAdicionadosItinerarios}/>
)

export default PainelFiltrosItinerarios
